import styled from "styled-components";

import { inheritRowStyles } from "#app/components/UI/styles";

export interface RowLayoutProps {
    flex?: boolean;
    flexWidth?: string;
    right?: boolean;
}

/**
 * Общий ряд формы (раньше в `pages/styles.js`). Явные пропсы для TypeScript.
 */
export const Row = styled.div<RowLayoutProps>`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    position: relative;
    align-items: center;

    &.source__creation-form-row .styled-input__pseudo-input.input > span,
    &.source__creation-form-row .styled-input__results-list.item > span {
        gap: 0.5em !important;
    }

    &.source__refuse-reason-row .styled-input__pseudo-input.input {
        border-radius: 0;
    }

    .source__application-status-select {
        border-radius: 0;
    }

    ${inheritRowStyles}

    .aton__select-flex {
        flex-basis: 30%;
    }

    @media screen and (max-width: 1660px) {
        .aton__select-flex {
            flex-basis: 40%;
        }
    }

    @media screen and (max-width: 1280px) {
        .aton__select-flex {
            flex-basis: 65%;
        }
    }

    ${(props) =>
        props.flex &&
        `
    flex: 1;
  `}

    ${(props) =>
        props.flexWidth &&
        `
      flex-basis: ${props.flexWidth};
  `}

    ${(props) =>
        props.right &&
        `
    justify-content: end;
  `}
`;
